import RankingContainer from "src/container/ranking";
import { Helmet } from "react-helmet-async";

const Ranking = () => {
  return (
    <>
      <Helmet>
        <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
        <meta name="description" content="검증 된 텔레모아 자체 스코어 적용, 가장 트렌디한 투자채널 순위를 확인하세요!" />
      </Helmet>
      <div className="container mt-4">
        <div className="row">
          <div className="px-3 py-4 col-12 col-lg-12">
            <RankingContainer rowPerPage={20} />
          </div>  
        </div>
      </div>
    </>
  );
}

export default Ranking;
